import { Loader } from '@googlemaps/js-api-loader';

/**
 * Shared Google Maps JS API loader.
 *
 * Both the site-wide header search (inputs.js) and the where-to-buy map
 * (index.js) import this module, so they share a single Loader instance and
 * the Maps JS API is fetched at most once per page.
 *
 * Crucially, the network request only happens when `loadMaps()` is first
 * called — i.e. on genuine user intent — not on page load. This is what keeps
 * the API off the vast majority of page views and reduces Google Maps cost.
 */

let loader = null;
let loadPromise = null;

const getLoader = () => {
    if (!loader) {
        loader = new Loader({
            apiKey: SWDLocalise.googleMapsAPIKey,
            // Only the Places library is used. The previous `geometry` library
            // was requested but never referenced (`google.maps.geometry.*`).
            libraries: ['places'],
            id: 'js-google-maps',
        });

        // Backwards-compatible global for any legacy/debug references.
        window.SWDLoader = loader;
    }

    return loader;
};

/**
 * Load the Google Maps JS API on demand. Memoised: repeat calls return the
 * same in-flight/resolved promise, so the library loads only once.
 *
 * @returns {Promise} resolves when the Maps API is ready.
 */
export const loadMaps = () => {
    if (!loadPromise) {
        loadPromise = getLoader().load();
    }

    return loadPromise;
};

export default loadMaps;
